module.exports = __webpack_public_path__ + "img/frozen_green_peas.8427f197.jpg";